module.exports = __webpack_public_path__ + "img/inventoryRight.e6929c09.svg";